

const statRegion =[
  { id: '1', value: "AU" },
  { id: '2', value: "NZ" },
  { id: '4', value: "US" },
  { id: '5', value: "UK" },
  { id: '6', value: "EU" }
];

export default statRegion;




// WEBPACK FOOTER //
// ./src/data/stat-region.js